import React from 'react';
import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd';
import { RangePickerProps as AntdRangePickerProps } from 'antd/es/date-picker';
import classNames from 'classnames';
import moment from 'moment';
import "moment/locale/ko";
import locale from "antd/lib/locale/ko_KR";

const RangePicker = ({ className, ...rest }: AntdRangePickerProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const { RangePicker }: any = AntdDatePicker;
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <ConfigProvider locale={locale}>
      <RangePicker
        className={classNames('range-picker', className)}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default RangePicker;
